import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, delay } from 'rxjs';
import {
  ATOS_ASSINADOS_FIXTURE,
  ATOS_FILA_ASSINATURA_FIXTURE,
  ATOS_FILA_REVISAO_FIXTURE,
  BOLETINS_PUBLICADOS_FIXTURE,
  SLA_DASHBOARD_FIXTURE,
  TODOS_ATOS_FIXTURE,
} from './boletim.fixtures';
import { criarMockAtoDetalhe, criarMockBoletimDetalhe } from '../utils/boletim-display.helper';
import { EstadoAto } from '../models/boletim.model';

function pageResponse<T>(content: T[], page = 0, size = 10) {
  return {
    content,
    page,
    size,
    totalElements: content.length,
  };
}

function filtrarAtos(estado?: string | null): typeof TODOS_ATOS_FIXTURE {
  if (!estado) return TODOS_ATOS_FIXTURE;
  return TODOS_ATOS_FIXTURE.filter(ato => ato.estado === estado);
}

export function handleBoletimRequest(
  req: HttpRequest<unknown>,
  delayMs = 400,
): Observable<HttpResponse<unknown>> | null {
  if (!req.url.includes('/v1/boletim')) {
    return null;
  }

  if (req.url.includes('/dashboard/sla')) {
    return of(new HttpResponse({ status: 200, body: SLA_DASHBOARD_FIXTURE })).pipe(delay(delayMs));
  }

  const atoDetalheMatch = req.url.match(/\/atos\/([^/?]+)$/);
  if (atoDetalheMatch && req.method === 'GET') {
    const id = atoDetalheMatch[1];
    const resumo = TODOS_ATOS_FIXTURE.find(ato => ato.id === id);
    if (resumo) {
      const contexto = resumo.estado === 'REVISADO' ? 'assinatura' : 'revisao';
      return of(
        new HttpResponse({ status: 200, body: criarMockAtoDetalhe(resumo, contexto) }),
      ).pipe(delay(delayMs));
    }
    return of(new HttpResponse({ status: 404, body: null })).pipe(delay(delayMs));
  }

  if (req.url.includes('/atos') && req.method === 'GET') {
    const url = new URL(req.url, 'http://localhost');
    const estado = url.searchParams.get('estado') as EstadoAto | null;
    const page = Number(url.searchParams.get('page') ?? 0);
    const size = Number(url.searchParams.get('size') ?? 10);
    let atos = filtrarAtos(estado);

    if (estado === 'AGUARDANDO_REVISAO') {
      atos = ATOS_FILA_REVISAO_FIXTURE;
    } else if (estado === 'REVISADO') {
      atos = ATOS_FILA_ASSINATURA_FIXTURE;
    } else if (estado === 'ASSINADO') {
      atos = ATOS_ASSINADOS_FIXTURE;
    }

    return of(new HttpResponse({ status: 200, body: pageResponse(atos, page, size) })).pipe(delay(delayMs));
  }

  const boletimDetalheMatch = req.url.match(/\/boletins\/([^/?]+)$/);
  if (boletimDetalheMatch && req.method === 'GET' && !req.url.endsWith('/pdf')) {
    const id = boletimDetalheMatch[1];
    const resumo = BOLETINS_PUBLICADOS_FIXTURE.find(b => b.id === id);
    if (resumo) {
      return of(
        new HttpResponse({ status: 200, body: criarMockBoletimDetalhe(resumo) }),
      ).pipe(delay(delayMs));
    }
    return of(new HttpResponse({ status: 404, body: null })).pipe(delay(delayMs));
  }

  if (req.url.includes('/boletins') && req.method === 'GET') {
    const url = new URL(req.url, 'http://localhost');
    const page = Number(url.searchParams.get('page') ?? 0);
    const size = Number(url.searchParams.get('size') ?? 10);
    return of(
      new HttpResponse({
        status: 200,
        body: pageResponse(BOLETINS_PUBLICADOS_FIXTURE, page, size),
      }),
    ).pipe(delay(delayMs));
  }

  if (req.url.includes('/atos/') && req.method === 'PATCH') {
    return of(new HttpResponse({ status: 200, body: criarMockAtoDetalhe(ATOS_FILA_REVISAO_FIXTURE[0]) })).pipe(
      delay(delayMs),
    );
  }

  if (req.url.includes('/assinar') && req.method === 'POST') {
    return of(new HttpResponse({ status: 200, body: criarMockAtoDetalhe(ATOS_FILA_ASSINATURA_FIXTURE[0], 'assinatura') })).pipe(
      delay(delayMs),
    );
  }

  if (req.url.endsWith('/boletins') && req.method === 'POST') {
    const body = req.body as { tipo?: string } | null;
    return of(
      new HttpResponse({
        status: 201,
        body: {
          id: '200',
          tipo: body?.tipo ?? 'BI',
          numero: 105,
          ano: 2026,
          dataPublicacao: '2026-06-09',
          estado: 'PUBLICADO',
          atos: [],
        },
      }),
    ).pipe(delay(delayMs));
  }

  return of(new HttpResponse({ status: 200, body: {} })).pipe(delay(delayMs));
}
